import axios from "axios";
import { appConstants, stringConstants } from "../helpers/app-constants";
import { BHAREE_BASE_URL_LOCAL } from "../config/config.url";

let options = {
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    Authorization: `Bearer ${localStorage.jwtToken}`,
  },
};

export const getUserBussinessInfomation = (userId, dispatch) => {
  axios
    .get(BHAREE_BASE_URL_LOCAL + "/users/" + userId, options)
    .then((res) => {
      dispatch({
        type: appConstants.GET_USER_BUSSINESS_INFORAMTION,
        payload: res.data.data,
        loading: false,
      });
    })
    .catch((err) =>
      dispatch({
        type: appConstants.LOADING_FAIL_USER_BUSSINESS_INFORAMTION,
        payload: err.response.data,
      })
    );
};

export const updateUserBussinessInfomation = (userId, upadtedData, dispatch) => {
  axios
    .patch(BHAREE_BASE_URL_LOCAL + "/users/" + userId, upadtedData)
    .then((res) => {
      return res;
    })
    .catch((err) =>
      dispatch({
        type: appConstants.LOADING_FAIL_USER_BUSSINESS_INFORAMTION,
        payload: err.response.data,
      })
    );
};

export const getLogisticPartners = async (userId, userType, dispatch) => {
  dispatch({ type: appConstants.LOADING_LOGISTIC_PARTNER, payload: {}, loading: true });

  try {
    let mUrl = BHAREE_BASE_URL_LOCAL + "/logistics";
    if (userType === stringConstants.ROLL_SELLER) {
      mUrl = mUrl + "/seller/" + userId;
    }
    const res = await axios.get(mUrl, options);
    dispatch({
      type: appConstants.GET_LOGISTIC_PARTNER,
      payload: res.data,
      loading: false,
    });
    return res.data; // ✅ return the response data
  } catch (err) {
    dispatch({
      type: appConstants.ERRORS_LOGISTIC_PARTNER,
      payload: err.response ? err.response.data : "Network Error",
      loading: false,
    });
    throw err; // rethrow if caller also needs to handle error
  }
};

export const getUserCompanyInfo = async (userId, dispatch) => {
  dispatch({ type: appConstants.LOADING_COMPANY_INFO, payload: {}, loading: true });

  try {
    const res = await axios.get(
      BHAREE_BASE_URL_LOCAL + "/users/companyInfo?qid=" + userId,
      options
    );
    dispatch({
      type: appConstants.GET_COMPANY_INFO,
      payload: res.data,
      loading: false,
    });
    return res.data; // ✅ return the response data
  } catch (err) {
    dispatch({
      type: appConstants.ERRORS_COMPANY_INFO,
      payload: err.response ? err.response.data : "Network Error",
      loading: false,
    });
    throw err; // rethrow if caller also needs to handle error
  }
};

export const patchUserCompanyInfo = async (userId, userData, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });

  try {
    const res = await axios.patch(
      BHAREE_BASE_URL_LOCAL + "/users/companyInfo?qid=" + userId,
      userData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.jwtToken} `,
        },
      }
    );
    dispatch({
      type: appConstants.REQUEST_COMPLETED,
      payload: res.data,
      loading: false,
    });
    return res.data; // ✅ return the response data
  } catch (err) {
    dispatch({
      type: appConstants.REQUEST_FAIL,
      payload: err.response ? err.response.data : "Network Error",
      loading: false,
    });
    throw err; // rethrow if caller also needs to handle error
  }
};

export const getUserBankingInfo = async (userId, dispatch) => {
  dispatch({ type: appConstants.LOADING_BANK_INFO, payload: {}, loading: true });

  try {
    const res = await axios.get(
      BHAREE_BASE_URL_LOCAL + "/users/getBankInfo?qid=" + userId,
      options
    );
    dispatch({
      type: appConstants.GET_BANK_INFO,
      payload: res.data,
      loading: false,
    });
    return res.data; // ✅ return the response data
  } catch (err) {
    dispatch({
      type: appConstants.ERRORS_BANK_INFO,
      payload: err.response ? err.response.data : "Network Error",
      loading: false,
    });
    throw err; // rethrow if caller also needs to handle error
  }
};

export const postUserBankInfo = async (userId, userData, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });

  try {
    const res = await axios.post(
      BHAREE_BASE_URL_LOCAL + "/users/updateBankInfo?qid=" + userId,
      userData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.jwtToken} `,
        },
      }
    );
    dispatch({
      type: appConstants.REQUEST_COMPLETED,
      payload: res.data,
      loading: false,
    });
    return res.data; // ✅ return the response data
  } catch (err) {
    dispatch({
      type: appConstants.REQUEST_FAIL,
      payload: err.response ? err.response.data : "Network Error",
      loading: false,
    });
    throw err; // rethrow if caller also needs to handle error
  }
};

export const getUserFactoryInfo = async (userId, dispatch) => {
  dispatch({ type: appConstants.LOADING_FACTORY_INFO, payload: {}, loading: true });

  try {
    const res = await axios.get(
      BHAREE_BASE_URL_LOCAL + "/users/getFactoryInfo?qid=" + userId,
      options
    );
    dispatch({
      type: appConstants.GET_FACTORY_INFO,
      payload: res.data,
      loading: false,
    });
    return res.data; // ✅ return the response data
  } catch (err) {
    dispatch({
      type: appConstants.ERRORS_FACTORY_INFO,
      payload: err.response ? err.response.data : "Network Error",
      loading: false,
    });
    throw err; // rethrow if caller also needs to handle error
  }
};

export const postUserFactoryInfo = async (userId, userData, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });

  try {
    const res = await axios.post(
      BHAREE_BASE_URL_LOCAL + "/users/updateFactoryInfo?qid=" + userId,
      userData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.jwtToken} `,
        },
      }
    );
    dispatch({
      type: appConstants.REQUEST_COMPLETED,
      payload: res.data,
      loading: false,
    });
    return res.data; // ✅ return the response data
  } catch (err) {
    dispatch({
      type: appConstants.REQUEST_FAIL,
      payload: err.response ? err.response.data : "Network Error",
      loading: false,
    });
    throw err; // rethrow if caller also needs to handle error
  }
};

export const getUserAddressInfo = async (userId, dispatch) => {
  dispatch({ type: appConstants.LOADING_ADDRESSES, payload: {}, loading: true });

  try {
    const res = await axios.get(
      BHAREE_BASE_URL_LOCAL + "/users/getAddressByUserId?qid=" + userId,
      options
    );
    dispatch({
      type: appConstants.GET_ADDRESSES,
      payload: res.data,
      loading: false,
    });
    return res.data; // ✅ return the response data
  } catch (err) {
    dispatch({
      type: appConstants.ERRORS_ADDRESSES,
      payload: err.response ? err.response.data : "Network Error",
      loading: false,
    });
    throw err; // rethrow if caller also needs to handle error
  }
};

export const postUserAddressInfo = async (userId, address, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });

  try {
    const res = await axios.post(
      BHAREE_BASE_URL_LOCAL + `/users/addAddress?qid=${userId}`,
      address,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.jwtToken} `,
        },
      }
    );
    dispatch({
      type: appConstants.REQUEST_COMPLETED,
      payload: res.data,
      loading: false,
    });
    return res.data; // ✅ return the response data
  } catch (err) {
    dispatch({
      type: appConstants.REQUEST_FAIL,
      payload: err.response ? err.response.data : "Network Error",
      loading: false,
    });
    throw err; // rethrow if caller also needs to handle error
  }
};

export const patchUserAddressInfo = async (userId, addressId, address, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });

  try {
    const res = await axios.patch(
      BHAREE_BASE_URL_LOCAL + `/users/updateAddress/${addressId}?qid=${userId}`,
      address,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.jwtToken} `,
        },
      }
    );
    dispatch({
      type: appConstants.REQUEST_COMPLETED,
      payload: res.data,
      loading: false,
    });
    return res.data; // ✅ return the response data
  } catch (err) {
    dispatch({
      type: appConstants.REQUEST_FAIL,
      payload: err.response ? err.response.data : "Network Error",
      loading: false,
    });
    throw err; // rethrow if caller also needs to handle error
  }
};

export const deleteUserAddressInfo = async (userId, addressId, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });

  try {
    const res = await axios.delete(
      BHAREE_BASE_URL_LOCAL + `/users/deleteAddress/${addressId}?qid=${userId}`,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.jwtToken} `,
        },
      }
    );
    dispatch({
      type: appConstants.REQUEST_COMPLETED,
      payload: res.data,
      loading: false,
    });
    return res.data; // ✅ return the response data
  } catch (err) {
    dispatch({
      type: appConstants.REQUEST_FAIL,
      payload: err.response ? err.response.data : "Network Error",
      loading: false,
    });
    throw err; // rethrow if caller also needs to handle error
  }
};

export const getUserSubscription = async (userId, dispatch) => {
  dispatch({ type: appConstants.LOADING_MY_SUBSCRIPTION, payload: {}, loading: true });

  try {
    const res = await axios.get(BHAREE_BASE_URL_LOCAL + "/users/mySubscription/" + userId, options);
    dispatch({
      type: appConstants.GET_MY_SUBSCRIPTION,
      payload: res.data.data,
      loading: false,
    });
    return res.data.data; // ✅ return the response data
  } catch (err) {
    dispatch({
      type: appConstants.ERRORS_MY_SUBSCRIPTION,
      payload: err.response ? err.response.data : "Network Error",
      loading: false,
    });
    throw err; // rethrow if caller also needs to handle error
  }
};

export const getInvoiceDetails = async (invoiceId, dispatch, qid = null) => {
  dispatch({ type: appConstants.LOADING_SUBSCRIPTION_INVOICE, payload: {}, loading: true });

  try {
    const mUrl = qid
      ? `${BHAREE_BASE_URL_LOCAL}/users/getInvoice/${invoiceId}?qid=${qid}`
      : `${BHAREE_BASE_URL_LOCAL}/users/getInvoice/${invoiceId}`;
    const res = await axios.get(mUrl, options);

    dispatch({
      type: appConstants.GET_SUBSCRIPTION_INVOICE,
      payload: res.data,
      loading: false,
    });

    return res.data; // ✅ return the response data
  } catch (err) {
    dispatch({
      type: appConstants.ERRORS_SUBSCRIPTION_INVOICE,
      payload: err.response ? err.response.data : "Network Error",
      loading: false,
    });
    throw err; // rethrow if caller also needs to handle error
  }
};
